import { ApiError } from '../api/client.js';

/** Shows a mutation error: the API's own message (Ukrainian) when there is one. */
export function ErrorText({ error }: { error: unknown }) {
  if (!error) return null;
  const message = error instanceof ApiError ? error.message : 'Щось пішло не так';
  return (
    <p role="alert" className="error-text">
      {message}
    </p>
  );
}
